
























































import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class PfForGet extends Vue {
  private form: any = {
    phone: null,
    verifyCode: null,
    newPwd: null,
    newConfirmPwd: null,
  };
  private timeCount = 0;
  private timer: any = null;
  private isShowCount = false;

  private async resetPassword() {
    if (
      this.form.phone &&
      this.form.verifyCode &&
      this.form.newPwd &&
      this.form.newConfirmPwd
    ) {
      if (this.form.newPwd !== this.form.newConfirmPwd) {
        this.$message.warning("新密码与确认新密码不一致");
        return;
      }
      try {
        await this.$apis.resetPassword(this.form);
        this.$message.success("设置新密码成功");
        this.handleToEmit("Login");
      } catch (error) {
        console.log(error);
      }
    } else {
      this.$message.warning("手机号, 验证码, 新密码, 确认新密码都不能为空");
    }
  }
  private async getVerifyCode() {
    if (this.form.phone) {
      await this.$apis.getVerifyCode({
        phone: this.form.phone,
        verifyCode: "0000",
        type: "2",
      });
      this.handleCount(60);
    } else {
      this.$message.warning("手机号码不能为空");
    }
  }
  private handleCount(count: number) {
    if (!this.timer) {
      this.timeCount = count;
      this.isShowCount = true;
      this.timer = setInterval(() => {
        if (this.timeCount > 0 && this.timeCount <= count) {
          this.timeCount--;
        } else {
          this.isShowCount = false;
          clearInterval(this.timer);
          this.timer = null;
        }
      }, 1000);
    }
  }
  private handleToEmit(componentName: any) {
    this.$emit("goto", componentName);
  }
  private created() {
    document.title = "忘记密码_" + this.$globalName;
  }
}
